<script>
import baseMixins from '@/plans/ZOOM_MEETING/config/base.vue';
import { mapState } from 'vuex';
import { isBizPlusContext, ZOOM_MEETING_SUB_TYPES, isZoomMeetingAsAddonCard } from '../common/utils';
import { maxBizAndBizPlusLicenseCount } from '@/common/constants';
import { flowTypes } from '@/common/service/page-config';
import ZoomMeetingDialogUtils from '../dialog/utils';
import modalMixin from '@/views/modal/modal-mx.js';

export default {
  name: 'ZoomMeetingBuyNow',
  mixins: [baseMixins, modalMixin],
  data() {
    return {
      showPlanDetail: true,
    };
  },
  computed: {
    ...mapState({
      updateBasePlan: (state) => state.Product.updateBasePlan,
    }),
    licenseAlertDesc() {
      return this.mx_defLicenseAlertDesc;
    },
    showExploreLink() {
      if (this.softBundleMeetingConfig?.hiddenSwitchCategoryEntry) return false;
      if (
        isBizPlusContext ||
        this.$context.is.edu ||
        this.$context.is.buyTrial ||
        this.formPlan?.category === ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP
      )
        return false;
      return this.form.selectedNumber < maxBizAndBizPlusLicenseCount;
    },
    showSwitchToClips() {
      return (
        [flowTypes.buyNow, flowTypes.basic2pro].includes(this.$context.flow) &&
        this.$core.draftPlanFilterKeys?.includes("CUSTOM_AVATARS")
      );
    },

    showIncreaseWithLargeMeetingPromo() {
      return (
        [flowTypes.buyNow, flowTypes.basic2pro].includes(this.$context.flow) &&
        [
          ZOOM_MEETING_SUB_TYPES.PRO,
          ZOOM_MEETING_SUB_TYPES.PRO_PLUS,
          ZOOM_MEETING_SUB_TYPES.BIZ,
          ZOOM_MEETING_SUB_TYPES.BIZ_PLUS,
          ZOOM_MEETING_SUB_TYPES.BIZ_INR,
        ].includes(this.formPlan?.category) &&
        !isZoomMeetingAsAddonCard() &&
        !this.$core.draftPlanFilterKeys.includes('LARGE_MEETING') &&
        this.$core.addonFilterKeys.includes('LARGE_MEETING') &&
        !this.isInClientModal
      );
    },
    showLargeMeetingPromoInComparison() {
      return (
        [flowTypes.buyNow, flowTypes.basic2pro].includes(this.$context.flow) &&
        [
          ZOOM_MEETING_SUB_TYPES.PRO,
          ZOOM_MEETING_SUB_TYPES.PRO_PLUS,
          ZOOM_MEETING_SUB_TYPES.BIZ,
          ZOOM_MEETING_SUB_TYPES.BIZ_PLUS,
          ZOOM_MEETING_SUB_TYPES.BIZ_INR,
        ].includes(this.formPlan?.category) &&
        !isZoomMeetingAsAddonCard() &&
        !this.isInClientModal &&
        (this.$core.draftPlanFilterKeys.includes('LARGE_MEETING') ||
          this.$core.addonFilterKeys.includes('LARGE_MEETING'))
      );
    },
  },
  watch: {
    'formPlan.category': {
      handler(val, oldVal) {
        if (val && oldVal) {
          ZoomMeetingDialogUtils.destoryComparisonDialog();
          ZoomMeetingDialogUtils.install(this.formPlan);
        }
      },
    },
    updateBasePlan: {
      handler(val) {
        val?.update && this.updateForm();
      },
    },
  },
};
</script>
